function normalizePercentageValue(value) {
  const hasValue = value !== null && value !== undefined && value !== ''
  const numericValue = hasValue ? Number(value) : Number.NaN
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0

  return Number(safeValue.toFixed(1))
}

// Returns a translated percentage string when i18n is provided, or a plain
// rounded string for render-only callers.
function formatScorePercentage(value, { translate } = {}) {
  const normalizedValue = normalizePercentageValue(value)

  if (!translate) {
    return String(normalizedValue)
  }

  return translate('routines.execution.percentage_value', {
    value: normalizedValue,
  })
}

export { formatScorePercentage, normalizePercentageValue }
